import { render, staticRenderFns } from "./exceptionSet.vue?vue&type=template&id=2da1a6fe&scoped=true&"
import script from "./exceptionSet.vue?vue&type=script&lang=js&"
export * from "./exceptionSet.vue?vue&type=script&lang=js&"
import style0 from "./exceptionSet.vue?vue&type=style&index=0&id=2da1a6fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da1a6fe",
  null
  
)

export default component.exports